import React from 'react';

const InfoIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...rest}>
      <path fillRule="evenodd" clipRule="evenodd" d="M8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8Z" fill="#6D7885" />
      <path fillRule="evenodd" clipRule="evenodd" d="M7 7.5C7 7.22386 7.22386 7 7.5 7H8C8.27614 7 8.5 7.22386 8.5 7.5V10.5C8.77614 10.5 9 10.7239 9 11C9 11.2761 8.77614 11.5 8.5 11.5H8C7.72386 11.5 7.5 11.2761 7.5 11V8C7.22386 8 7 7.77614 7 7.5Z" fill="#6D7885" />
      <path d="M7.875 6C8.28921 6 8.625 5.66421 8.625 5.25C8.625 4.83579 8.28921 4.5 7.875 4.5C7.46079 4.5 7.125 4.83579 7.125 5.25C7.125 5.66421 7.46079 6 7.875 6Z" fill="#6D7885" />
    </svg>
  );
};

export default InfoIcon;